import { render, staticRenderFns } from "./AddDocumentModal.vue?vue&type=template&id=9883db32&scoped=true"
import script from "./AddDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentModal.vue?vue&type=style&index=0&id=9883db32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9883db32",
  null
  
)

export default component.exports